(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DiscountRate', DiscountRate);

    DiscountRate.$inject = ['$resource'];

    function DiscountRate ($resource) {
        var resourceUrl =  'api/discount-rates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
